









import { Watch, Prop, Component, Vue } from "vue-property-decorator";
import {
  Company,
  Office,
  getOtherCompanies,
  deleteCompany
} from "@/api/company-api";
import saveCompany from "@/helpers/saveCompany";
import TaskType from "@/entities/task-type";
import CompanyEdit from "@/templates/CompanyEdit.vue";

@Component({
  components: {
    CompanyEdit
  }
})
export default class CompanyEditPage extends Vue {
  @Prop({ required: true }) id!: string;

  company: Company | null = null;
  office: Office | null = null;

  async ok() {
    if (!this.company || !this.office) return;
    await saveCompany(this.company, this.office);
    this.goShowPage();
  }

  cancel() {
    this.goShowPage();
  }

  async remove() {
    if (!this.company) return;
    await deleteCompany(this.company.companyId);
    this.goListPage();
  }

  private companies: Company[] = [];

  created() {
    this.$store.dispatch("tasktype/init");
    this.initCompanies();
  }

  private async initCompanies() {
    this.companies = await getOtherCompanies();
    this.selectCompany();
  }

  @Watch("id")
  private selectCompany() {
    const c = this.companies.find(c => String(c.companyId) === this.id);
    if (c) {
      this.company = { ...c };
      this.office = { ...c.office };
    } else {
      this.company = null;
      this.office = null;
    }
  }

  private goListPage() {
    this.$router.push({ name: "companies-list" });
  }

  private goShowPage() {
    const params = { id: this.id };
    this.$router.push({ name: "companies-show", params });
  }

  get tasktypes(): TaskType[] {
    return this.$store.getters["tasktype/all"];
  }
}
